import MaterialTable from "components/Table/MaterialTable";
import React, { useState, useEffect } from "react";
import {
  getwtdVoteType,
  editwtdVoteType,
  addwtdVoteType,
  deletewtdVoteType
} from "contexts/API/WTD/common";
import { useSweetAlert } from "components/Alert/SweetAlert";
const VoteType = props => {
  const [columns] = useState([
    {
      title: "wtdVoteTypeId",
      field: "wtdVoteTypeId",
      hidden: true
    },
    {
      title: "ประเภทการเลือกตั้ง",
      field: "detail",
      cellStyle: {
        minWidth: "800px"
      }
    }
  ]);
  const optionsTable = { pageSize: 10 };
  const [data, setData] = useState([]);
  const { sweetAlerts } = useSweetAlert();
  useEffect(() => {
    getwtdVoteType()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MaterialTable
      title={"ประเภทการเลือกตั้ง"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
              addwtdVoteType(newData.detail)
                .then(result => {
                  newData.wtdVoteTypeId = result.data.data.wtdVoteTypeId;
                  setData([...data, newData]);
                  sweetAlerts.success("เพิ่มข้อมูลเรียบร้อยแล้ว");
                  
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถเพิ่มข้อมูลได้", err.toString());
                });

              resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
              const dataUpdate = [...data];
              const index = oldData.tableData.id;
              dataUpdate[index] = newData;
              editwtdVoteType(oldData.wtdVoteTypeId, newData.detail)
                .then(result => {
                  sweetAlerts.success("แก้ไขข้อมูลเรียบร้อยแล้ว");
                  setData([...dataUpdate]);
                })
                .catch(err => {
                  const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                  sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
                });

              resolve();
          }),
        onRowDelete: oldData =>
          new Promise((resolve, reject) => {
              const dataDelete = [...data];
              const index = oldData.tableData.id;
              dataDelete.splice(index, 1);
              deletewtdVoteType(oldData.wtdVoteTypeId)
                .then(result => {
                  sweetAlerts.success("ลบข้อมูลเรียบร้อยแล้ว");
                  setData([...dataDelete]);
                })
                .catch(err => {
                  sweetAlerts.error("ไม่สามารถลบข้อมูลได้", err.toString());
                });

              resolve();
          })
      }}
    />
  );
};
export default VoteType;
